const weeks = [
  {
    num: "Week 1",
    title: "Scope & auth",
    text: "Define initial use case (FAQ + balance/transaction queries is typical). Map the bank IdP integration. Sign DPA and security questionnaire.",
  },
  {
    num: "Week 2",
    title: "Knowledge & tuning",
    text: "Ingest the bank's knowledge base (fee schedules, product terms, FAQs). Tune prompts against representative customer queries.",
  },
  {
    num: "Week 3",
    title: "Brand & UI",
    text: "Apply the bank's design tokens. Customise greeting and recovery flows. Wire up Article 50 transparency disclosure.",
  },
  {
    num: "Week 4",
    title: "Internal pilot",
    text: "Launch to internal users (bank staff). Monitor with Langfuse. Refine. 6-8 weeks to live customer pilot is the realistic case.",
  },
];

export const PilotTimeline = () => (
  <>
    <div className="pilot-timeline">
      {weeks.map((w) => (
        <div className="pilot-week" key={w.num}>
          <div className="pilot-week-num">{w.num}</div>
          <h4>{w.title}</h4>
          <p>{w.text}</p>
        </div>
      ))}
    </div>

    <div className="pilot-split">
      <div>
        <h5>Bank provides</h5>
        <ul>
          <li>Knowledge base content</li>
          <li>IdP integration contact</li>
          <li>Brand design tokens</li>
          <li>Executive sponsor</li>
        </ul>
      </div>
      <div>
        <h5>Bancony provides</h5>
        <ul>
          <li>Server runtime, deployment, monitoring</li>
          <li>Prompt engineering and tuning</li>
          <li>UI integration via iframe / WebView</li>
          <li>DPIA template, compliance evidence</li>
        </ul>
      </div>
    </div>
  </>
);
